var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-primary rounded d-flex align-items-center justify-content-between p-3 mb-3 shadow-lg"
  }, [_vm._m(0), _c('b-button', {
    attrs: {
      "variant": "dark",
      "size": "sm"
    },
    on: {
      "click": _vm.goToNewDashboard
    }
  }, [_vm._v(" Quero conhecer ")])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "bi bi-bell-fill me-2 text-white"
  }), _c('div', [_c('strong', {
    staticClass: "text-white"
  }, [_vm._v("Novo Dashboard Disponível!")]), _c('p', {
    staticClass: "mb-0 text-light small"
  }, [_vm._v(" Confira a nova versão mais completa. ")])])]);
}];
export { render, staticRenderFns };